import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setFormData } from 'Services/Features/Admin/adminSlice';

const SelectCategory = () => {
    const dispatch = useDispatch();
    const currentAdmin = useSelector(state => state.admin.currentAdmin);
    const filter = useSelector(state => state.category.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeCategory = (selectedOption) => {
        setSelectedValue(selectedOption === null ? '' : selectedOption);
        dispatch(setFormData({ branch_id: selectedOption === null ? '' : selectedOption.value }));
    };

    useEffect(() => {
        const selectedCategory = currentAdmin.branch_id ? {
            value: currentAdmin.branch_id,
            label: currentAdmin.branch_name,
        } : null;
        setSelectedValue(selectedCategory);
    }, []);

    const promiseOptionCategory = (inputValue, callback) => {
        dispatch(getBranch({
            ...filter,
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionCategory}
            handleChange={(selectedOption) => handleChangeCategory(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Kategori"
            isMulti={false}
        />
    )
}

export default SelectCategory;
